<div class="h-full flex flex-column bg-surface-50 overflow-hidden" style="min-height: 100vh;">

    <div *ngIf='isLoading' class="flex flex-column align-items-center justify-content-center p-6">
        <h5>{{spinnerMessage}}</h5>
        <p-progressSpinner></p-progressSpinner>
    </div>

    <ng-container *ngIf="!isLoading">
        <!-- PREMIUM HEADER -->
        <div class="glass-header flex flex-column md:flex-row align-items-start md:align-items-center gap-4 px-4 pt-4 mx-4 mt-4 mb-0">
            <div class="flex align-items-center gap-3 flex-grow-1">
                <p-button icon="pi pi-arrow-left" [text]="true" severity="secondary" (onClick)="back()" [rounded]="true" pTooltip="Volver"></p-button>
                <div class="item-visual" [style.background]="getVisualGradient()">
                    <i [class]="getAssayIcon()"></i>
                </div>
                <div class="flex flex-column gap-1">
                    <div class="flex align-items-center gap-2 flex-wrap">
                        <h1 class="text-2xl font-bold m-0 text-900 line-height-1">
                            {{ form.get('name')?.value || formTitle || 'Nuevo Ensayo' }}
                        </h1>
                        <span class="px-3 py-1 bg-indigo-100 text-indigo-700 border-round-xl text-sm font-bold border-1 border-indigo-200" *ngIf="form.get('code')?.value">
                            {{ form.get('code')?.value }}
                        </span>
                    </div>
                    <div class="flex align-items-center gap-3 text-500 text-sm mt-1">
                        <span class="flex align-items-center gap-1">
                            <i class="pi pi-info-circle text-primary"></i>
                            {{ getCategoryLabel(form.get('category')?.value) || form.get('kind')?.value || 'Sin categoría' }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="flex gap-2 flex-shrink-0">
                <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary" (onClick)="closeDialog()" [rounded]="true"></p-button>
                <p-button *ngIf="activeTabIndex === '0' || activeTabIndex === '1' || activeTabIndex === '3'" 
                          label="Guardar" icon="pi pi-save" (onClick)="save(form.value)"
                          [disabled]="disbledSaveButton()" [loading]="isSaving" [rounded]="true" severity="primary"></p-button>
            </div>
        </div>

        <!-- MAIN CONTENT AREA -->
        <div class="flex-grow-1 overflow-y-auto px-4 py-3 scroll-container">
            <div class="flex flex-column lg:flex-row gap-4">

                <!-- LEFT COLUMN (FORM TABS) -->
                <div class="flex-grow-1 p-0" [ngClass]="activeTabIndex === '2' || activeTabIndex === '4' ? 'col-12' : 'lg:col-8 xl:col-9'">
                    <div class="surface-card border-round-xl shadow-1 bg-white overflow-hidden">
                        <p-tabs [(value)]="activeTabIndex" class="custom-tabs">
                            <p-tablist>
                                <p-tab value="0"><i class="pi pi-th-large mr-2"></i> <span>1. Clasificación</span></p-tab>
                                <p-tab value="1"><i class="pi pi-id-card mr-2"></i> <span>2. Datos Generales</span></p-tab>
                                <p-tab value="2"
                                    [disabled]="parentSingnals.value != signals.PARENT_IS_SAVED || !dataSavedOnDB"><i class="pi pi-list mr-2"></i> <span>3. Determinaciones</span></p-tab>
                                <p-tab value="3"><i class="pi pi-users mr-2"></i> <span>4. Asignaciones</span></p-tab>
                                <p-tab value="4"
                                    [disabled]="parentSingnals.value != signals.PARENT_IS_SAVED || !dataSavedOnDB"><i class="pi pi-file-pdf mr-2"></i> <span>5. Documentos</span></p-tab>
                            </p-tablist>
                            <p-tabpanels>
                                <!-- TAB 0: CLASSIFICATION -->
                                <p-tabpanel value="0">
                        <div class="p-4 flex flex-column gap-4">
                            <div>
                                <div class="text-xl font-bold mb-2">Clasificación Técnica</div>
                                <p class="text-500 m-0 line-height-3">Seleccione la categoría principal que define la naturaleza analítica y el método técnico de este ensayo. Esta clasificación permite agrupar y organizar mejor los recursos del laboratorio.</p>
                            </div>

                            <div *ngIf="!form.get('category')?.value && dataSavedOnDB" class="surface-50 border-round-xl p-3 flex align-items-center gap-3 text-600 border-1 border-300 border-dashed animate-fadein">
                                <i class="pi pi-info-circle text-xl text-primary"></i>
                                <span><strong>Atención:</strong> Aún no se ha asignado una categoría a este ensayo. Haga clic en una de las opciones debajo para clasificarlo.</span>
                            </div>

                            <div class="grid mt-2">
                                @for(opt of categories; track opt.value){
                                    <div class="col-12 md:col-6 lg:col-4">
                                        <div class="premium-card-select p-3 cursor-pointer flex align-items-center gap-3"
                                            [class.active]="form.get('category')?.value === opt.value"
                                            (click)="selectCategory(opt.value)">
                                            <div class="type-icon-circle">
                                                <i [class]="opt.icon"></i>
                                            </div>
                                            <div class="flex flex-column">
                                                <span class="font-bold text-sm" [class.text-primary]="form.get('category')?.value === opt.value">{{ opt.label }}</span>
                                                <small class="text-500 line-height-2">{{ opt.description }}</small>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </p-tabpanel>

                    <!-- TAB 1: DATOS GENERALES -->
                    <p-tabpanel value="1">
                        <div class="p-4">
                            <form [formGroup]='form' (ngSubmit)="save(documentEditForm.form.value)"
                                #documentEditForm="ngForm">

                            <!-- Grid layout for better organization -->
                            <div class="form-grid">



                                <!-- Row 1: Code, Name -->
                                <div class="form-field">
                                    <p-floatLabel>
                                        <input pInputText id="code" formControlName='code' autocomplete="off"
                                            trim='blur' class="w-full" />
                                        <label for="code">Código</label>
                                    </p-floatLabel>
                                    <small *ngIf="this.form.controls.code.invalid" class="p-error">
                                        {{ getErrorMessage(form.controls.code) }}
                                    </small>
                                </div>

                                <div class="form-field form-field-wide">
                                    <p-floatLabel>
                                        <input pInputText id="name" formControlName='name' autocomplete="off"
                                            class="w-full" />
                                        <label for="name">Nombre</label>
                                    </p-floatLabel>
                                    <small *ngIf="this.form.controls.name.invalid" class="p-error">
                                        {{ getErrorMessage(form.controls.name) }}
                                    </small>
                                </div>

                                <!-- Row 2: Report Name, Report Name English -->
                                <div class="form-field form-field-wide">
                                    <p-floatLabel>
                                        <input pInputText id="reportName" formControlName='reportName'
                                            autocomplete="off" class="w-full" />
                                        <label for="reportName">Nombre Reporte</label>
                                    </p-floatLabel>
                                    <small *ngIf="this.form.controls.reportName.invalid" class="p-error">
                                        {{ getErrorMessage(form.controls.reportName) }}
                                    </small>
                                </div>

                                <div class="form-field form-field-wide">
                                    <p-floatLabel>
                                        <input pInputText id="reportNameEnglish" formControlName='reportNameEnglish'
                                            autocomplete="off" class="w-full" />
                                        <label for="reportNameEnglish">Nombre en inglés</label>
                                    </p-floatLabel>
                                    <small *ngIf="this.form.controls.reportNameEnglish.invalid" class="p-error">
                                        {{ getErrorMessage(form.controls.reportNameEnglish) }}
                                    </small>
                                </div>

                                <!-- Row 3: Abbreviation, Kind, Molecular Kind -->
                                <div class="form-field">
                                    <p-floatLabel>
                                        <input pInputText id="abbreviation" formControlName='abbreviation'
                                            class="w-full" />
                                        <label for="abbreviation">Abreviatura</label>
                                    </p-floatLabel>
                                    <small *ngIf="this.form.controls.abbreviation.invalid" class="p-error">
                                        {{ getErrorMessage(form.controls.abbreviation) }}
                                    </small>
                                </div>

                                <div class="form-field">
                                    <p-floatLabel>
                                        <p-select id="kind" formControlName='kind' [options]="methodsKinds | keyvalue"
                                            optionLabel="value" optionValue="value" [disabled]="hasAnalites()"
                                            class="w-full" />
                                        <label for="kind">Tipo de ensayo</label>
                                    </p-floatLabel>
                                </div>

                                <div class="form-field" *ngIf="showMolecularKind()">
                                    <p-floatLabel>
                                        <p-select id="molecular_kind" formControlName='molecular_kind'
                                            [options]="molecularKinds" [disabled]="hasAnalites()" class="w-full">
                                            <ng-template let-item pTemplate="item">
                                                {{molecularKindsValues.get(item)}}
                                            </ng-template>
                                            <ng-template let-item pTemplate="selectedItem">
                                                {{molecularKindsValues.get(item)}}
                                            </ng-template>
                                        </p-select>
                                        <label for="molecular_kind">Tipo ensayo molecular</label>
                                    </p-floatLabel>
                                </div>

                                <!-- Row 4: Report Kind, Form Kind, Z-Index -->
                                <div class="form-field">
                                    <p-floatLabel>
                                        <p-select id="reportKind" formControlName='reportKind'
                                            [options]="reportsKinds | keyvalue" optionLabel="value" optionValue="value"
                                            class="w-full" />
                                        <label for="reportKind">Tipo de reporte</label>
                                    </p-floatLabel>
                                </div>

                                <div class="form-field" *ngIf="checkShowControl('assay', 'formKind')">
                                    <p-floatLabel>
                                        <p-multiSelect id="formKind" formControlName='formKind' [options]="VetMolKind"
                                            display="chip" class="w-full">
                                            <ng-template let-item pTemplate="item">
                                                {{VetMolKindMap.get(item)}}
                                            </ng-template>
                                        </p-multiSelect>
                                        <label for="formKind">Tipo de Formularios</label>
                                    </p-floatLabel>
                                </div>

                                <div class="form-field">
                                    <p-floatLabel>
                                        <input pInputText id="z_index" formControlName='z_index' autocomplete="off"
                                            class="w-full" />
                                        <label for="z_index">Prioridad de Informe</label>
                                    </p-floatLabel>
                                    <small *ngIf="this.form.controls.z_index.invalid" class="p-error">
                                        El campo debe ser un número
                                    </small>
                                </div>

                                <!-- Row 5: Matrix -->
                                <div class="form-field">
                                    <p-floatLabel>
                                        <p-multiSelect id="matrix" [formControlName]='getMatrixControlName()'
                                            [options]="filteredMatrix()" optionLabel="value" optionValue="id"
                                            display="chip" [filter]="true" filterBy="value,code"
                                            (onShow)="filteredMatrix.set(opts.matrixOpts())"
                                            (onChange)="dropdownSelectionChange($event, 'matrix_v2Ids', 'matrixOptsSG', filteredMatrix)"
                                            class="w-full">
                                            <ng-template let-matrix pTemplate="item">
                                                {{matrix.value}} - {{matrix.code}}
                                            </ng-template>
                                            <ng-template #footer>
                                                <div class="p-3">
                                                    <p-button type="button"
                                                        (onClick)="buttonConfig(getMatrixControlName(), 'FormTechConfig', 'matrix', 'techConfigs', 'matrixOptsSG', filteredMatrix)"
                                                        label="Agregar Matriz" [fluid]="true" severity="secondary"
                                                        [text]="true" size="small" icon="pi pi-plus"></p-button>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                        <label for="matrix">Matriz</label>
                                    </p-floatLabel>
                                </div>

                                <!-- Row 6: Method -->
                                <div class="form-field">
                                    <p-floatLabel>
                                        <p-select id="methodId" formControlName='methodId' [options]="filteredMethods()"
                                            optionLabel="value" optionValue="id" [filter]="true" filterBy="value,code"
                                            class="w-full" (onShow)="filteredMethods.set(opts.methodsOpts())" [showClear]="true">
                                            <ng-template let-method pTemplate="item">
                                                {{method.value}} - {{method.code}}
                                            </ng-template>
                                            <ng-template #footer>
                                                <div class="p-3">
                                                    <p-button type="button"
                                                        (onClick)="buttonConfig('methodId', 'FormTechConfig', 'methods', 'techConfigs', 'methodsOptsSG', filteredMethods)"
                                                        label="Agregar Método" [fluid]="true" severity="secondary"
                                                        [text]="true" size="small" icon="pi pi-plus"></p-button>
                                                </div>
                                            </ng-template>
                                        </p-select>
                                        <label for="methodId">Método</label>
                                    </p-floatLabel>
                                </div>

                                <!-- Row 7: Assay Groups -->
                                <div class="form-field form-field-wide">
                                    <p-floatLabel>
                                        <p-multiSelect id="assayGroupsIds" formControlName='assayGroupsIds'
                                            [options]="filteredAssaysGroups()" optionLabel="name" optionValue="id"
                                            display="chip" [filter]="true" filterBy="name,code"
                                            (onShow)="filteredAssaysGroups.set(opts.assaysGroupsOpts())"
                                            (onChange)="dropdownSelectionChange($event, 'assayGroupsIds', 'assaysGroupsOptsSG', filteredAssaysGroups)"
                                            class="w-full">
                                            <ng-template let-assayGroup pTemplate="item">
                                                {{assayGroup.name}} - {{assayGroup.code}}
                                            </ng-template>
                                        </p-multiSelect>
                                        <label for="assayGroupsIds">Grupos de ensayo</label>
                                    </p-floatLabel>
                                </div>


                                <!-- Row 9: Default Results (conditional) -->
                                <div class="form-field" *ngIf="form.get('kind').value == 'Default'">
                                    <p-floatLabel>
                                        <p-select id="defaultCualResult" formControlName='defaultCualResult'
                                            [options]="filteredCualResults()" optionLabel="value" optionValue="value"
                                            [filter]="true" filterBy="value"
                                            (onShow)="filteredCualResults.set(opts.cualResultsOpts())"
                                            (onChange)="dropdownSelectionChange($event, 'defaultCualResult', 'cualResultsOptsSG', filteredCualResults)"
                                            class="w-full">
                                        </p-select>
                                        <label for="defaultCualResult">Resultado cualitativo default</label>
                                    </p-floatLabel>
                                </div>

                                <div class="form-field" *ngIf="form.get('kind').value == 'Default'">
                                    <p-floatLabel>
                                        <input pInputText id="defaultResult" formControlName='defaultResult'
                                            autocomplete="off" class="w-full" />
                                        <label for="defaultResult">Resultado default</label>
                                    </p-floatLabel>
                                    <small *ngIf="this.form.controls.defaultResult.invalid" class="p-error">
                                        {{ getErrorMessage(form.controls.defaultResult) }}
                                    </small>
                                </div>

                                @if(isBio){
                              <div class="form-field">
                                  <p-floatLabel>
                                      <p-select id="bioGroupId" formControlName='bioGroupId'
                                          [options]="filteredBioGroups()" optionLabel="value" optionValue="id"
                                          class="w-full" [filter]="true" filterBy="value,code">
                                          <ng-template let-bioGroup pTemplate="item">
                                              {{bioGroup.value}} - {{bioGroup.code}}
                                          </ng-template>
                                      </p-select>
                                      <label for="bioGroupId">Grupo Bioquímica</label>
                                  </p-floatLabel>
                              </div>
                            }
                            </div>

                            <!-- Toggles Section -->
                            <div class="toggles-section">
                                <div class="toggle-group">
                                    <p-toggleSwitch formControlName='active' inputId="active" />
                                    <label for="active">Activo</label>
                                </div>

                                <div class="toggle-group" *ngIf="multiHumidityAdjustmentActive()">
                                    <p-toggleSwitch formControlName='multi_humidity_adjustment'
                                        inputId="multi_humidity" />
                                    <label for="multi_humidity">Ajuste Multi Humedad</label>
                                </div>

                                <div class="toggle-group">
                                    <p-toggleSwitch formControlName='groupConclusions' inputId="groupConclusions" />
                                    <label for="groupConclusions">Agrupar conclusión</label>
                                </div>

                                <div class="toggle-group">
                                    <p-toggleSwitch formControlName='individualLabel' inputId="individualLabel" />
                                    <label for="individualLabel">Etiqueta individual</label>
                                </div>

                                <div class="toggle-group" *ngIf="derivedActive()">
                                    <p-toggleSwitch formControlName='derived' inputId="derived" />
                                    <label for="derived">Derivado</label>
                                </div>

                                <div class="toggle-group">
                                    <p-toggleSwitch formControlName='externalValidation' inputId="externalValidation" />
                                    <label for="externalValidation">Auto validación</label>
                                </div>
                            </div>

                            <!-- Supplier and Dates Section -->
                            <div class="form-grid" *ngIf="needsSupplier() || formControls.externalValidation.value">
                                <div class="form-field" *ngIf="needsSupplier()">
                                    <p-floatLabel>
                                        <p-select id="supplier" formControlName='supplier'
                                            [options]="filteredServiceSuppliers()" optionLabel="value" optionValue="id"
                                            [filter]="true" filterBy="value,code"
                                            (onShow)="filteredServiceSuppliers.set(opts.serviceSupplierOpts())"
                                            class="w-full">
                                            <ng-template let-supplier pTemplate="item">
                                                {{supplier.value}} - {{supplier.code}}
                                            </ng-template>
                                            <ng-template #footer>
                                                <div class="p-3">
                                                    <p-button type="button"
                                                        (onClick)="buttonConfig('supplier', 'FormAdminConfigComponent', 'serviceSuppliers','adminConfigs', 'serviceSupplierOptsSG', filteredServiceSuppliers )"
                                                        label="Agregar Proveedor" [fluid]="true" severity="secondary"
                                                        [text]="true" size="small" icon="pi pi-plus"></p-button>
                                                </div>
                                            </ng-template>
                                        </p-select>
                                        <label for="supplier">Proveedor</label>
                                    </p-floatLabel>
                                </div>

                                <div class="form-field" *ngIf="derivedTillFromActive()">
                                    <p-floatLabel>
                                        <p-calendar formControlName='derivedFrom' [showIcon]="true"
                                            dateFormat="dd/mm/yy" placeholder="Desde" inputId="derivedFrom"
                                            class="w-full" />
                                        <label for="derivedFrom">Derivación Desde</label>
                                    </p-floatLabel>
                                    <small *ngIf="formControls.derivedFrom.errors?.derivative" class="p-error">
                                        Ingresar fecha de origen
                                    </small>
                                </div>

                                <div class="form-field" *ngIf="derivedTillFromActive()">
                                    <p-floatLabel>
                                        <p-calendar formControlName='derivedTill' [showIcon]="true"
                                            dateFormat="dd/mm/yy" placeholder="Hasta" inputId="derivedTill"
                                            class="w-full" />
                                        <label for="derivedTill">Derivación Hasta</label>
                                    </p-floatLabel>
                                    <small *ngIf="formControls.derivedTill.errors?.derivative" class="p-error">
                                        Ingresar fecha de cierre
                                    </small>
                                </div>

                                <div class="form-field" *ngIf="formControls.externalValidation.value">
                                  <p-floatLabel>
                                    <input pInputText id="externalValidationSource"
                                    formControlName='externalValidationSource' autocomplete="off"
                                    class="w-full" />
                                    <label for="externalValidationSource">Origen de validación</label>
                                  </p-floatLabel>
                                </div>
                              </div>


                            <!-- Metrics Section (Cost + Time) -->
                            <div class="metrics-container">
                                <!-- Cost Card -->
                                <div class="cost-card-container"
                                    *ngIf='parentSingnals.value == signals.PARENT_IS_SAVED'>
                                    <p-card styleClass="cost_card">
                                        <ng-template pTemplate="content">
                                            <div class="cost-card-inner">
                                                <div class="money_container">
                                                    <i class="pi pi-dollar"></i>
                                                </div>
                                                <div class="cost-subtitle">Costo ensayo</div>
                                                <span class="cost-amount">{{currencyConfig.symbol}} {{assayCost}}</span>
                                            </div>
                                        </ng-template>
                                    </p-card>
                                </div>

                                <!-- Time Indicators Section -->
                                <p-card [header]="'Indicadores de tiempos'" *ngIf="showTimes()">
                                    <div formGroupName="adminConfig" class="form-grid">

                                        <div class="form-field" *ngIf="showTimePerReplication()">
                                            <p-floatLabel>
                                                <input pInputText id="timePerReplication"
                                                    formControlName='timePerReplication' autocomplete="off"
                                                    class="w-full" />
                                                <label for="timePerReplication">Tiempo análisis (Horas)</label>
                                            </p-floatLabel>
                                            <small *ngIf="adminConfig?.timePerReplication?.invalid" class="p-error">
                                                {{ getErrorMessage(adminConfig?.timePerReplication) }}
                                            </small>
                                        </div>

                                        <div class="form-field" *ngIf="showDelay()">
                                            <p-floatLabel>
                                                <input pInputText id="greenDays" formControlName='greenDays'
                                                    autocomplete="off" class="w-full" />
                                                <label for="greenDays">Límite Verde</label>
                                            </p-floatLabel>
                                            <small *ngIf="adminConfig?.greenDays?.invalid" class="p-error">
                                                {{ getErrorMessage(adminConfig?.greenDays) }}
                                            </small>
                                        </div>

                                        <div class="form-field" *ngIf="showDelay()">
                                            <p-floatLabel>
                                                <input pInputText id="yellowDays" formControlName='yellowDays'
                                                    autocomplete="off" class="w-full" />
                                                <label for="yellowDays">Límite Amarillo</label>
                                            </p-floatLabel>
                                            <small *ngIf="adminConfig?.yellowDays?.invalid" class="p-error">
                                                {{ getErrorMessage(adminConfig?.yellowDays) }}
                                            </small>
                                        </div>

                                        <div class="form-field" *ngIf="showDelay()">
                                            <p-floatLabel>
                                                <input pInputText id="redDays" formControlName='redDays'
                                                    autocomplete="off" class="w-full" />
                                                <label for="redDays">Límite Rojo</label>
                                            </p-floatLabel>
                                            <small *ngIf="adminConfig?.redDays?.invalid" class="p-error">
                                                {{ getErrorMessage(adminConfig?.redDays) }}
                                            </small>
                                        </div>

                                        <div class="form-field" *ngIf="showDelay()">
                                            <p-floatLabel>
                                                <p-select appendTo="body" id="time_unit" formControlName='time_unit'
                                                    [options]="timesUnitsEnum | keyvalue" optionValue="value"
                                                    class="w-full">
                                                    <ng-template let-timeUnit pTemplate="item">
                                                        {{timesUnitsMap.get(timeUnit.value)}}
                                                    </ng-template>
                                                    <ng-template let-timeUnit pTemplate="selectedItem">
                                                        {{timesUnitsMap.get(timeUnit.value)}}
                                                    </ng-template>
                                                </p-select>
                                                <label for="time_unit">Unidad de tiempo</label>
                                            </p-floatLabel>
                                        </div>

                                    </div>
                                </p-card>
                            </div>

                            <!-- Observations -->
                            <div class="form-field-full">
                                <p-floatLabel>
                                    <textarea pInputTextarea id="observations" formControlName='observations'
                                        (focus)="observationControlGetFocus()" (blur)="observationControlLostFocus()"
                                        rows="3" [autoResize]="true" class="w-full"></textarea>
                                    <label for="observations">Observaciones</label>
                                </p-floatLabel>
                            </div>

                            <!-- Text Editor -->
                            @if(this.configService?.appSettings?.frontend?.forms?.assay?.textEditor?.active){
                            <div class="editor-section">
                                <h5>Información de preparación</h5>
                                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor class="editor" [editor]="editor" [formControl]='this.preparation_info'
                                    placeholder="Ingresar información de preparación"></ngx-editor>
                            </div>
                            }

                        </form>
                    </div>
                </p-tabpanel>
                    <p-tabpanel value="2">
                        <div class="p-4">
                            <app-table-assay-analites *ngIf='parentSingnals.value == signals.PARENT_IS_SAVED && !isLoading'
                                (assayCost)='assayCost = $event'
                                [parentSignals]='parentSingnals.asObservable()'></app-table-assay-analites>
                        </div>
                    </p-tabpanel>
                    <p-tabpanel value="3">
                        <div class="p-4">
                            <div [formGroup]="form" class="p-fluid">
                            <div class="mb-4 surface-ground p-3 border-round">
                                <p class="m-0 text-color-secondary"><i class="pi pi-info-circle mr-2"></i>Los analistas y supervisores disponibles para seleccionar dependerán directamente de los sectores que tenga asignados este ensayo. Si el ensayo no tiene un sector específico, podrán seleccionarse todos los usuarios.</p>
                            </div>

                            <div class="form-grid">
                                <!-- Sectors -->
                                <div class="form-field col-12 md:col-12">
                                    <p-floatLabel>
                                        <p-multiSelect id="sectors" formControlName='sectors'
                                            [options]="filteredSectors()" optionLabel="value" optionValue="id"
                                            display="chip" [filter]="true" filterBy="value"
                                            (onShow)="filteredSectors.set(opts.sectorsOpts())"
                                            (onChange)="dropdownSelectionChange($event, 'sectors', 'sectorsOptsSG', filteredSectors)"
                                            class="w-full">
                                            <ng-template let-sector pTemplate="item">
                                                {{sector.value}}
                                            </ng-template>
                                            <ng-template #footer>
                                                <div class="p-3">
                                                    <p-button type="button"
                                                        (onClick)="buttonConfig('sectors', 'FormTechConfig', 'sectors', 'techConfigs', 'sectorsOptsSG', filteredSectors)"
                                                        label="Agregar Sector" [fluid]="true" severity="secondary"
                                                        [text]="true" size="small" icon="pi pi-plus"></p-button>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                        <label for="sectors">Sectores del Ensayo</label>
                                    </p-floatLabel>
                                </div>

                                <!-- Analysts -->
                                <div class="form-field col-12 md:col-6">
                                    <p-floatLabel>
                                        <p-multiSelect id="authorizedAnalysts" formControlName='authorizedAnalysts'
                                            [options]="filteredAnalysts()" optionLabel="name" optionValue="id"
                                            display="chip" [filter]="true" filterBy="name,lastName,initials"
                                            (onChange)="dropdownSelectionChange($event, 'authorizedAnalysts', 'analystsOptsSG', filteredAnalysts)"
                                            class="w-full">
                                            <ng-template let-user pTemplate="item">
                                                {{user.name}} {{user.lastName}} ({{user.initials}})
                                            </ng-template>
                                        </p-multiSelect>
                                        <label for="authorizedAnalysts">Analistas asignados</label>
                                    </p-floatLabel>
                                </div>


                                </div>
                            </div>
                        </div>
                    </p-tabpanel>
                    <p-tabpanel value="4">
                        <div class="p-4">
                            <app-assay-documents-tab *ngIf="parentSingnals.value == signals.PARENT_IS_SAVED && !isLoading" [assay]="currentAssay"></app-assay-documents-tab>
                        </div>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>
    </div>

                <!-- RIGHT COLUMN (SUMMARY SIDEBAR) -->
                <div class="col-12 lg:col-4 xl:col-3 p-0 flex flex-column gap-3" *ngIf="activeTabIndex !== '2' && activeTabIndex !== '4'">
                    <!-- IDENTIFICATION SUMMARY -->
                    <div class="sidebar-info-card border-top-3 border-primary">
                        <div class="flex justify-content-between align-items-center mb-3">
                            <span class="text-900 font-bold">Identificación</span>
                            <i class="pi pi-id-card text-primary text-xl"></i>
                        </div>

                        <div class="flex flex-column gap-3">
                            <div class="flex flex-column gap-1">
                                <span class="text-500 text-xs uppercase font-bold">Nombre Completo</span>
                                <span class="text-900 font-medium line-height-2">{{ form.get('name')?.value || 'Sin nombre' }}</span>
                            </div>
                            <div class="grid grid-nogutter">
                                <div class="col-6 flex flex-column gap-1">
                                    <span class="text-500 text-xs uppercase font-bold">Código</span>
                                    <span class="text-primary font-bold">{{ form.get('code')?.value || '—' }}</span>
                                </div>
                                <div class="col-6 flex flex-column gap-1 border-left-1 border-100 pl-3">
                                    <span class="text-500 text-xs uppercase font-bold">Abrev.</span>
                                    <span class="text-900 font-bold">{{ form.get('abbreviation')?.value || '—' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- TECHNICAL SUMMARY -->
                    <div class="sidebar-info-card border-top-3 border-teal-500" *ngIf="form.get('category')?.value || form.get('kind')?.value || form.get('methodId')?.value">
                        <div class="flex justify-content-between align-items-center mb-3">
                            <span class="text-900 font-bold">Detalles Técnicos</span>
                            <i class="pi pi-cog text-teal-500 text-xl"></i>
                        </div>

                        <div class="flex flex-column gap-3 text-sm">
                            <div class="flex justify-content-between align-items-center" *ngIf="form.get('category')?.value">
                                <span class="text-500">Categoría:</span>
                                <span class="font-bold text-900 text-right">{{ getCategoryLabel(form.get('category')?.value) }}</span>
                            </div>
                            <div class="flex justify-content-between align-items-center" *ngIf="form.get('kind')?.value">
                                <span class="text-500">Tipo:</span>
                                <span class="font-bold text-900">{{ form.get('kind')?.value }}</span>
                            </div>
                            <div class="flex justify-content-between align-items-center" *ngIf="getSelectedMethodName()">
                                <span class="text-500">Método:</span>
                                <span class="font-bold text-primary text-right">{{ getSelectedMethodName() }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- METRICS & COST SUMMARY -->
                    <div class="sidebar-info-card border-top-3 border-green-500" *ngIf="parentSingnals.value == signals.PARENT_IS_SAVED">
                        <div class="flex justify-content-between align-items-center mb-3">
                            <span class="text-900 font-bold">Costo y Tiempos</span>
                            <i class="pi pi-dollar text-green-500 text-xl"></i>
                        </div>
                        <div class="flex flex-column gap-3 text-sm">
                            <div class="flex justify-content-between align-items-center">
                                <span class="text-500 text-xs uppercase font-bold">Costo Ensayo:</span>
                                <span class="font-bold text-green-600 text-base">{{ currencyConfig.symbol }} {{ assayCost }}</span>
                            </div>
                            <div class="flex justify-content-between align-items-center" *ngIf="adminConfig?.timePerReplication?.value">
                                <span class="text-500 text-xs uppercase font-bold">Tiempo Análisis:</span>
                                <span class="font-bold text-900">{{ adminConfig.timePerReplication.value }} hs</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </ng-container>
</div>
